export { useChangeMyPassword, useChangePassword } from './use-change-password';
